import { useMutation } from '@debbie/common/dist/util/hooks.js';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { errorNotification } from '../utils/errors.js';
import EditText from './Icons/EditText.js';
import { Button, Checkbox, Input, Modal } from './index.js';
const Edit = (props) => {
    const lang = useSelector((s) => s.lang);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [value, setValue] = useState('');
    const [boolValue, setBoolValue] = useState(false);
    const toggleModal = () => setEditModalOpen(!editModalOpen);
    useEffect(() => {
        props.value && setValue(props.value);
    }, [props.value]);
    useEffect(() => {
        props.boolValue && setBoolValue(props.boolValue);
    }, [props.boolValue]);
    const updateMutation = useMutation(() => {
        if (props.isBool) {
            return props.onUpdate(boolValue);
        }
        else {
            return props.onUpdate(value);
        }
    }, {
        onSuccess: () => {
            setEditModalOpen(false);
        },
        onError: (err) => {
            errorNotification(lang, err, 'update', props.placeholder);
        },
    });
    const update = () => {
        updateMutation.mutate();
    };
    return (React.createElement(Wrapper, null,
        React.createElement(StyledEditText, { onClick: toggleModal }),
        editModalOpen && (React.createElement(Modal, { onToggle: toggleModal, header: props.placeholder }, props.isBool ? (React.createElement(React.Fragment, null,
            React.createElement(Checkbox, { placeholder: props.placeholder, checked: boolValue, onChange: (e) => {
                    setBoolValue(e.target.checked);
                } }),
            React.createElement("br", null),
            React.createElement(Button, { loading: updateMutation.isLoading, onClick: update, block: true }, lang.misc.save))) : (React.createElement(Input, { placeholder: props.placeholder, autofocus: true, value: value, onChange: (e) => {
                setValue(e.target.value);
            }, onSubmit: () => update() }))))));
};
export default Edit;
const Wrapper = styled.div `
  padding-left: 8px;
  vertical-align: middle;
  display: inline-block;
`;
const StyledEditText = styled(EditText) `
  width: 16px;
  height: 16px;
  cursor: pointer;
`;
//# sourceMappingURL=Edit.js.map